import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { SdkWebhookUpdateInput } from '../generated/globalTypes';
import { updateSdkWebhookMutation, updateSdkWebhookMutationVariables } from '../generated/updateSdkWebhookMutation';
import { sdkWebhookFieldsFragment } from '../models/SdkWebhook';

/**
 * Get a callback to update a SdkWebhook in the store.
 */
export function useUpdateSdkWebhookCallback(): [(id: string, model: SdkWebhookUpdateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<updateSdkWebhookMutation, updateSdkWebhookMutationVariables>(
        gql`
            mutation updateSdkWebhookMutation ($model: SdkWebhookUpdateInput!) {
                updateSdkWebhook(model: $model) {
                    ...sdkWebhookFields
                }
            }

            ${sdkWebhookFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string, model: SdkWebhookUpdateInput) => {
        const result = await mutationAction({ variables: { model: { ...model, id: id } } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
